class Helper {
  requireModule: any

  constructor(requireModule: any) {
    this.requireModule = requireModule
  }

  modules() {
    const container: any = {}

    this.requireModule.keys().forEach((filename: any) => {
      if (!filename.match(/^\.\/\w+\/index.js$/g)) {
        return null
      }
      // create the module name from fileName
      // remove the store.js extension and capitalize
      const nameContainer = filename.replace(/^(\.\/|index\.js$)/g, '').split('/')
      const moduleName = nameContainer.shift().replace(/^\w/, (c: any) => c.toUpperCase())
      container[moduleName] = this.requireModule(filename).default || this.requireModule(filename)
    })
    return container
  }
}

export default Helper
